export const STATUS_ACTIVE = 'ACTIVE';
export const STATUS_ASSIGNED = 'ASSIGNED';
export const STATUS_AUTHORIZED = 'AUTHORIZED';
export const STATUS_AVAILABLE = 'AVAILABLE';
export const STATUS_BLOCK = 'BLOCK';
export const STATUS_BLOCKED = 'BLOCKED';
export const STATUS_BURNING = 'BURNING';
export const STATUS_BURNT = 'BURNT';
export const STATUS_CHARGING = 'CHARGING';
export const STATUS_CLOSED = 'CLOSED';
export const STATUS_DEACTIVE = 'DEACTIVE';
export const STATUS_DELETED = 'DELETED';
export const STATUS_DISCARDED = 'DISCARDED';
export const STATUS_DISMISSED = 'DISMISSED';
export const STATUS_ELABORATED = 'ELABORATED';
export const STATUS_ENABLED = 'ENABLED';
export const STATUS_EXPIRED = 'EXPIRED';
export const STATUS_FAULTED = 'FAULTED';
export const STATUS_FINISHED = 'FINISHED';
export const STATUS_FINISHING = 'FINISHING';
export const STATUS_INACTIVE = 'INACTIVE';
export const STATUS_INSTALLED = 'INSTALLED';
export const STATUS_NOT_ACTIVE = 'NOT_ACTIVE';
export const STATUS_NOT_AVAILABLE = 'NOT_AVAILABLE';
export const STATUS_NOT_USED = 'NOT_USED';
export const STATUS_NOTACTIVE = 'NOTACTIVE';
export const STATUS_NOTDISMISSED = 'NOT_DISMISSED';
export const STATUS_OCCUPIED = 'OCCUPIED';
export const STATUS_OFFLINE = 'OFFLINE';
export const STATUS_ONGOING = 'ONGOING';
export const STATUS_OPEN = 'OPEN';
export const STATUS_PARTIALFAULTED = 'PARTIALFAULTED';
export const STATUS_PARTIALOCCUPIED = 'PARTIALOCCUPIED';
export const STATUS_PENDING = 'PENDING';
export const STATUS_PLANNED = 'PLANNED';
export const STATUS_PLUGGEDIN = 'PLUGGEDIN';
export const STATUS_PRE_ACTIVATED = 'PRE_ACTIVATED';
export const STATUS_PRE_ACTIVE = 'PRE-ACTIVE';
export const STATUS_PREPARING = 'PREPARING';
export const STATUS_PROCESSING = 'PROCESSING';
export const STATUS_PUBLISHED = 'PUBLISHED';
export const STATUS_REACHABLE = 'REACHABLE';
export const STATUS_RESERVED = 'RESERVED';
export const STATUS_STANDALONE = 'STANDALONE';
export const STATUS_STANDBYCS = 'STANDBYCS';
export const STATUS_STANDBYVEHICLE = 'STANDBYVEHICLE';
export const STATUS_SUSPENDED = 'SUSPENDED';
export const STATUS_SUSPENDEDEV = 'SUSPENDEDEV';
export const STATUS_SUSPENDEDEVSE = 'SUSPENDEDEVSE';
export const STATUS_SWITCHEDOFF = 'SWITCHEDOFF';
export const STATUS_TEMPORARY_NOT_AVAILABLE = 'TEMPORARY_NOT_AVAILABLE';
export const STATUS_UNAVAILABLE = 'UNAVAILABLE';
export const STATUS_UNREACHABLE = 'UNREACHABLE';
export const STATUS_USED = 'USED';

export const stationStatus = {
  [STATUS_AVAILABLE]: {
    label: 'stationStatus.available',
    color: (p) => p.theme.colors.status.green,
  },
  [STATUS_PLUGGEDIN]: {
    label: 'stationStatus.pluggedin',
    color: (p) => p.theme.colors.status.lightBlue,
  },
  [STATUS_SWITCHEDOFF]: {
    label: 'stationStatus.switchedoff',
    color: (p) => p.theme.colors.graph.yellow,
  },
  [STATUS_UNREACHABLE]: {
    label: 'stationStatus.unreachable',
    color: (p) => p.theme.colors.status.grey,
  },
  [STATUS_OCCUPIED]: {
    label: 'stationStatus.occupied',
    color: (p) => p.theme.colors.status.cherryRed,
  },
  [STATUS_UNAVAILABLE]: {
    label: 'stationStatus.unavailable',
    color: (p) => p.theme.colors.status.yellow,
  },
  [STATUS_FAULTED]: {
    label: 'stationStatus.faulted',
    color: (p) => p.theme.colors.status.violetPurple,
  },
  [STATUS_PARTIALFAULTED]: {
    label: 'stationStatus.partialfaulted',
    color: (p) => p.theme.colors.status.pink,
  },
  [STATUS_REACHABLE]: {
    label: 'stationStatus.reachable',
    color: (p) => p.theme.colors.graph.lightBlue,
  },
  [STATUS_RESERVED]: {
    label: 'stationStatus.reserved',
    color: (p) => p.theme.colors.graph.orange,
  },
  [STATUS_DISMISSED]: {
    label: 'stationStatus.dismissed',
    color: (p) => p.theme.colors.graph.textGrey,
  },
  [STATUS_PARTIALOCCUPIED]: {
    label: 'stationStatus.partialOccupied',
    color: (p) => p.theme.colors.status.cherryRed,
  },
  [STATUS_INSTALLED]: {
    label: 'stationStatus.installed',
    color: (p) => p.theme.colors.graph.blue,
  },
  [STATUS_PLANNED]: {
    label: 'stationStatus.planned',
    color: (p) => p.theme.colors.graph.azureLight,
  },
  [STATUS_PLUGGEDIN]: {
    label: 'stationStatus.pluggedin',
    color: (p) => p.theme.colors.status.violetPurple,
  },
};

// this const should be renamed cause it's used among all the files
export const chargingSessionsStatus = {
  [STATUS_ACTIVE]: {
    id: STATUS_ACTIVE,
    label: 'main.status.active',
    color: (p) => p.theme.colors.status.green,
  },
  [STATUS_AUTHORIZED]: {
    id: STATUS_AUTHORIZED,
    label: 'main.status.authorized',
    color: (p) => p.theme.colors.status.grey,
  },
  [STATUS_FINISHED]: {
    id: STATUS_FINISHED,
    label: 'main.status.finished',
    color: (p) => p.theme.colors.status.cherryRed,
  },
  [STATUS_FINISHING]: {
    id: STATUS_FINISHING,
    label: 'main.status.finishing',
    color: (p) => p.theme.colors.status.violetPurple,
  },
  [STATUS_STANDBYVEHICLE]: {
    id: STATUS_STANDBYVEHICLE,
    label: 'main.status.standbyvehicle',
    color: (p) => p.theme.colors.status.violetPurple,
  },
  [STATUS_STANDBYCS]: {
    id: STATUS_STANDBYCS,
    label: 'main.status.standbycs',
    color: (p) => p.theme.colors.status.violetPurple,
  },
  [STATUS_RESERVED]: {
    id: STATUS_RESERVED,
    label: 'main.status.reserved',
    color: (p) => p.theme.colors.status.yellow,
  },
  [STATUS_ONGOING]: {
    id: STATUS_ONGOING,
    label: 'main.status.ongoing',
    color: (p) => p.theme.colors.status.grey,
  },
  [STATUS_INACTIVE]: {
    id: STATUS_INACTIVE,
    label: 'main.status.inactive',
    color: (p) => p.theme.colors.status.grey,
  },
};

export const couponsStatus = {
  [STATUS_ACTIVE]: {
    label: 'status.active',
    color: (p) => p.theme.colors.status.green,
  },
  [STATUS_EXPIRED]: {
    label: 'status.expired',
    color: (p) => p.theme.colors.status.cherryRed,
  },
  [STATUS_NOT_ACTIVE]: {
    label: 'status.notActive',
    color: (p) => p.theme.colors.status.cherryRed,
  },
  [STATUS_BURNT]: {
    label: 'status.used', // used
    color: (p) => p.theme.colors.graph.blue,
  },
  [STATUS_DELETED]: {
    label: 'status.deleted',
    color: (p) => p.theme.colors.graph.orange,
  },
};

export const reportsStatus = {
  [STATUS_OPEN]: {
    label: 'main.status.open',
    color: (p) => p.theme.colors.status.violetPurple,
  },
  [STATUS_ASSIGNED]: {
    label: 'main.status.assigned',
    color: (p) => p.theme.colors.status.green,
  },
  [STATUS_PROCESSING]: {
    label: 'main.status.processing',
    color: (p) => p.theme.colors.status.cherryRed,
  },
  [STATUS_ELABORATED]: {
    label: 'main.status.elaborated',
    color: (p) => p.theme.colors.status.grey,
  },
};

export const profileStatus = {
  [STATUS_ACTIVE]: {
    label: 'main.status.active',
    color: (p) => p.theme.colors.status.green,
  },
  [STATUS_INACTIVE]: {
    label: 'main.status.inactive',
    color: (p) => p.theme.colors.status.grey,
  },
};

export const driverStatus = {
  [STATUS_USED]: {
    label: 'list.filters.used',
    color: 'grey',
  },
  [STATUS_NOT_USED]: {
    label: 'list.filters.notUsed',
    color: 'green',
  },
  [STATUS_BURNING]: {
    label: 'list.filters.burning',
    color: 'cherryRed',
  },
};

export default {
  chargingSessionsStatus,
  couponsStatus,
  reportsStatus,
  stationStatus,
  STATUS_ACTIVE,
  STATUS_ASSIGNED,
  STATUS_AUTHORIZED,
  STATUS_AVAILABLE,
  STATUS_BLOCK,
  STATUS_BLOCKED,
  STATUS_BURNING,
  STATUS_BURNT,
  STATUS_CHARGING,
  STATUS_CLOSED,
  STATUS_DEACTIVE,
  STATUS_DELETED,
  STATUS_DISCARDED,
  STATUS_DISMISSED,
  STATUS_ELABORATED,
  STATUS_ENABLED,
  STATUS_EXPIRED,
  STATUS_FAULTED,
  STATUS_FINISHED,
  STATUS_FINISHING,
  STATUS_INACTIVE,
  STATUS_INSTALLED,
  STATUS_NOT_ACTIVE,
  STATUS_NOT_AVAILABLE,
  STATUS_NOT_USED,
  STATUS_NOTACTIVE,
  STATUS_NOTDISMISSED,
  STATUS_OCCUPIED,
  STATUS_OFFLINE,
  STATUS_ONGOING,
  STATUS_OPEN,
  STATUS_PARTIALFAULTED,
  STATUS_PARTIALOCCUPIED,
  STATUS_PENDING,
  STATUS_PLANNED,
  STATUS_PLUGGEDIN,
  STATUS_PRE_ACTIVATED,
  STATUS_PRE_ACTIVE,
  STATUS_PREPARING,
  STATUS_PROCESSING,
  STATUS_PUBLISHED,
  STATUS_REACHABLE,
  STATUS_RESERVED,
  STATUS_STANDALONE,
  STATUS_STANDBYCS,
  STATUS_STANDBYVEHICLE,
  STATUS_SUSPENDED,
  STATUS_SUSPENDEDEV,
  STATUS_SUSPENDEDEVSE,
  STATUS_SWITCHEDOFF,
  STATUS_TEMPORARY_NOT_AVAILABLE,
  STATUS_UNAVAILABLE,
  STATUS_UNREACHABLE,
  STATUS_USED,
  driverStatus,
};
